import { format, isToday } from "date-fns"
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const SmallWeekViewCalendar = ({displayedWeek, setSelectedDay, setView, containerNav}) => {

    const goToDayView = (day) => {
        setSelectedDay({date: day, events: [], availabilities: []})
        setView('Day view')
      }

    return (
        <div ref={containerNav} className="sticky top-0 z-30 flex-none bg-white shadow ring-1 ring-black ring-opacity-5 sm:pr-0">
          <div className="grid grid-cols-7 text-sm leading-6 text-gray-500 sm:hidden">
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              S <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              M <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              T <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              W{' '}<span className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 font-semibold text-white">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              T <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              F <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
            <button type="button" className="flex flex-col items-center pt-2 pb-3">
              S <span className="mt-1 flex h-8 w-8 items-center justify-center font-semibold text-gray-900">111</span>
            </button>
          </div>

          <div className="-mr-px hidden grid-cols-7 divide-x bg-gray-100 rounded-t-2xl divide-gray-100 border-r border-gray-100 text-sm leading-6 text-gray-500 sm:grid">
            <div className="col-end-1 w-14" />
            {displayedWeek.map((date, index) => (
              <div key={index} className="flex items-center justify-center py-3 text-gray-600">
                <span className={classNames(isToday(date) && 'bg-purple-600 text-white py-0 px-2 rounded-xl', "w-18 text-center cursor-pointer")} onClick={() => goToDayView(date)}>
                  <span className={classNames(isToday(date) && 'text-white', "items-center p-0 w-6 block m-auto justify-center font-extrabold text-xl")}>{format(date, 'd')}</span>
                  <div className='-mt-1'>{format(date, 'eee')}</div>
                </span>
              </div>
            ))}
          </div>
        </div>
    )
}
export default SmallWeekViewCalendar